import { z } from 'zod/v4';

import { pcmWsAvoidFavorLinkSchema } from './pcm-ws-avoid-favor-link';

export const pcmWsAvoidFavorInfoSchema = z.object({
  AvoidFavorType: z.number(),
  GroupComments: z.string().nullable(),
  GroupName: z.string(),
  GroupID: z.number().nullable(),
  GroupLinks: z.array(pcmWsAvoidFavorLinkSchema),
  SetID: z.number(),
});

export type PcmWsAvoidFavorInfo = z.infer<typeof pcmWsAvoidFavorInfoSchema>;
